import { Skeleton } from '@mui/material';
import { useOutletContext } from 'react-router-dom';
const PageNotarialInfo = () => {

    const {details,isLoading} = useOutletContext();


    return (

        <div className="card card-action mb-4">
            <div className="card-header">
                <div className="d-flex mb-3 gap-3">
                    <div>
                        <span className="badge bg-label-primary rounded-2">
                            <i className="bx bx-briefcase-alt-2 bx-md" />
                        </span>
                    </div>
                    <div>
                        <h4 className="mb-0">
                            <span className="align-middle">Notarial Info</span>
                        </h4>
                        <span>Real-time information of your notary.</span>
                    </div>
                </div>
            </div>

            <div className="card-body">
         
                <table className="table table-bordered" style={{ borderRadius: 10 }}>

                    <tbody>

                        {(() => {
                            if (isLoading) {
                                return Array.from({ length: 12 }).map((_, index) => (
                                    <tr key={index}>
                                        <td className='text-center' colSpan={2}>
                                            <Skeleton animation="wave" variant="text" width="100%" height={20} sx={{  bgcolor: 'grey.200' }} />
                                        </td>
                                    </tr>
                                ));
                            }

                            return (
                                <>
                                    <tr>
                                        <td className="pe-3" width={250}><i className="bx bx-briefcase" /><span className="fw-bold mx-2">Notary Name:</span></td>
                                        <td className="fw-bold">{details?.enp_notary_name}</td>
                                    </tr>
                                    <tr>
                                        <td className="pe-3"><i className="bx bx-hash" /><span className="fw-bold mx-2">Roll No:</span></td>
                                        <td className="fw-bold">{details?.enp_roll_no}</td>
                                    </tr>
                                    <tr>
                                        <td className="pe-3"><i className="bx bx-hash" /><span className="fw-bold mx-2">IBP No:</span></td>
                                        <td className="fw-bold">{details?.enp_ibp_no}</td>
                                    </tr>
                                    <tr>
                                        <td className="pe-3"><i className="bx bx-hash" /><span className="fw-bold mx-2">Commission No:</span></td>
                                        <td className="fw-bold">{details?.enp_commission_no}</td>
                                    </tr>
                                    <tr>
                                        <td className="pe-3"><i className="bx bx-calendar" /><span className="fw-bold mx-2">Expiry Date:</span></td>
                                        <td className="fw-bold">{details?.enp_commission_expiry_date}</td>
                                    </tr>
                                    <tr>
                                        <td className="pe-3"><i className="bx bx-hash" /><span className="fw-bold mx-2">Compliance No:</span></td>
                                        <td className="fw-bold">{details?.enp_compliance_no}</td>
                                    </tr>
                                    <tr>
                                        <td className="pe-3"><i className="bx bx-briefcase" /><span className="fw-bold mx-2">Date Issued:</span></td>
                                        <td className="fw-bold">{details?.enp_compliance_issued_date}</td>
                                    </tr>

                                    <tr>
                                        <td className="pe-3"><i className="bx bx-hash" /><span className="fw-bold mx-2">PTR No:</span></td>
                                        <td className="fw-bold">{details?.enp_ptr_no}</td>
                                    </tr>
                                    <tr>
                                        <td className="pe-3"><i className="bx bx-calendar" /><span className="fw-bold mx-2">Date Issued:</span></td>
                                        <td className="fw-bold">{details?.enp_ptr_issued_date}</td>
                                    </tr>
                                    <tr>
                                        <td className="pe-3"><i className="bx bx-current-location" /><span className="fw-bold mx-2">Issued at:</span></td>
                                        <td className="fw-bold">{details?.enp_ptr_issued_place}</td>
                                    </tr>
                                    <tr>
                                        <td className="pe-3"><i className="bx bx-map-pin" /><span className="fw-bold mx-2">Notary Address:</span></td>
                                        <td className="fw-bold">{details?.enp_address}</td>
                                    </tr>
                                    <tr>
                                        <td className="pe-3"><i className="bx bx-envelope" /><span className="fw-bold mx-2">Notary Email:</span></td>
                                        <td className="fw-bold">{details?.enp_email}</td>
                                    </tr>
                                </>
                            )


                        })()}
 
                    </tbody>

                </table>
            </div>
        </div>
    );
}

export default PageNotarialInfo;